const rootState = {
    parent: 'root',
    url: '',
    abstract: true,
    template: '<ui-view></ui-view>'
};

const uploadState = {
    url: '/upload',
    template: require('./controllers/upload/upload.html'),
    controller: require('./controllers/upload/uploadCtrl'),
    requireToken: true
};

const importRootState = {
    parent: 'root',
    url: '/imports',
    abstract: true,
    template: '<ui-view></ui-view>',
    onEnter: $rootScope => {
        $rootScope.openTasksPullout = false;
    },
    onExit: $rootScope => {
        $rootScope.openTasksPullout = true;
    }
};

const importListState = {
    url: '?exportId',
    template: require('./controllers/import/list/import-list.html'),
    controller: require('./controllers/import/list/importListCtrl'),
    controllerAs: 'importList',
    requireToken: true
};

const importDetailState = {
    url: '/:importId',
    template: require('./controllers/import/detail/import-detail.html'),
    controller: require('./controllers/import/detail/importDetailCtrl'),
    requireToken: true
};

export default function (app) {
    app.config(($stateProvider, userRolesObject) => {
        rootState.data = {
            roles: [userRolesObject.admin, userRolesObject.operator, userRolesObject.teamLead, userRolesObject.rrd]
        };

        importRootState.data = {
            roles: [userRolesObject.admin, userRolesObject.operator, userRolesObject.teamLead, userRolesObject.rrd]
        };

        importListState.data = {
            roles: [userRolesObject.admin, userRolesObject.operator, userRolesObject.teamLead, userRolesObject.rrd]
        };

        $stateProvider
            .state('data-import-export', rootState);

        $stateProvider
            .state('data-import-export.upload', uploadState);

        $stateProvider
            .state('data-import-export.import', importRootState)
            .state('data-import-export.import.list', importListState)
            .state('data-import-export.import.detail', importDetailState);
    });
}



// WEBPACK FOOTER //
// ./Client/app/data-import-export/routes.js